module.exports = __webpack_public_path__ + "static/WindingWorlds0-f716fc289fbb5433bb69da04e279cf30.png";